// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Soundboard Modal & Popover */
.soundboard-backdrop {
  position: fixed;
  inset: 0;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.15s ease-out;
}

.soundboard-backdrop.bottom-sidebar {
  align-items: flex-end;
  justify-content: flex-start;
  padding-left: 80px;
  padding-bottom: 75px;
  background: transparent;
  backdrop-filter: none;
}

.soundboard-modal-container {
  width: 440px;
  max-width: 95vw;
  background: #1e1f22;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 14px;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.65), 0 0 0 1px rgba(255, 255, 255, 0.05);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: scaleIn 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes scaleIn {
  from { opacity: 0; transform: scale(0.94) translateY(10px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}

.soundboard-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  background: #2b2d31;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.soundboard-title-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.soundboard-icon-badge {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: linear-gradient(135deg, #5865F2, #8b5cf6);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(88, 101, 242, 0.4);
}

.soundboard-header h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 800;
  color: #fff;
}

.soundboard-close-btn {
  background: transparent;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.soundboard-close-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

/* Toolbar */
.soundboard-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 16px;
  background: #232428;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.soundboard-search-box {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
}

.soundboard-search-box .search-icon {
  position: absolute;
  left: 10px;
  color: #80848e;
  pointer-events: none;
}

.soundboard-search-input {
  width: 100%;
  background: #111214;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  padding: 7px 12px 7px 32px;
  font-size: 12px;
  color: #fff;
  outline: none;
  transition: border-color 0.15s;
}

.soundboard-search-input:focus {
  border-color: #5865F2;
}

.soundboard-vol-control {
  display: flex;
  align-items: center;
  gap: 6px;
}

.vol-icon-btn {
  background: transparent;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
}

.soundboard-vol-slider {
  width: 75px;
  height: 4px;
  accent-color: #5865F2;
  cursor: pointer;
}

.vol-text {
  font-size: 11px;
  color: #94a3b8;
  font-family: monospace;
  min-width: 28px;
}

/* Tabs */
.soundboard-tabs {
  display: flex;
  gap: 6px;
  padding: 10px 16px 6px 16px;
  overflow-x: auto;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.soundboard-tab-btn {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid transparent;
  color: #94a3b8;
  padding: 5px 12px;
  border-radius: 14px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s;
}

.soundboard-tab-btn:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

.soundboard-tab-btn.active {
  background: #5865F2;
  color: #fff;
  box-shadow: 0 2px 8px rgba(88, 101, 242, 0.35);
}

/* Grid */
.soundboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
  padding: 14px 16px;
  max-height: 320px;
  overflow-y: auto;
}

.sound-tile {
  position: relative;
  background: #2b2d31;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 10px;
  padding: 12px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  user-select: none;
}

.sound-tile:hover {
  background: #35373c;
  border-color: rgba(88, 101, 242, 0.5);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.35);
}

.sound-tile:active {
  transform: scale(0.96);
  background: #5865F2;
}

.sound-emoji {
  font-size: 26px;
  line-height: 1;
}

.sound-name {
  font-size: 12px;
  font-weight: 700;
  color: #e2e8f0;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.sound-tile:hover .sound-name {
  color: #fff;
}

.sound-delete-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(239, 68, 68, 0.2);
  border: none;
  color: #ef4444;
  border-radius: 4px;
  padding: 2px 4px;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s;
}

.sound-tile:hover .sound-delete-btn {
  opacity: 1;
}

.sound-tile.add-tile {
  border: 1px dashed rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.02);
  color: #94a3b8;
}

.sound-tile.add-tile:hover {
  background: rgba(88, 101, 242, 0.1);
  border-color: #5865F2;
  color: #5865F2;
}

/* Add custom sound modal */
.soundboard-add-modal-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 100;
}

.soundboard-add-modal {
  width: 100%;
  max-width: 340px;
  background: #2b2d31;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  padding: 18px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}

.soundboard-add-modal h4 {
  margin: 0 0 6px 0;
  font-size: 15px;
  font-weight: 800;
  color: #fff;
}

.soundboard-add-modal p {
  margin: 0 0 14px 0;
  font-size: 11px;
  color: #94a3b8;
  line-height: 1.4;
}

.add-field {
  margin-bottom: 12px;
}

.add-field label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: #cbd5e1;
  margin-bottom: 5px;
}

.add-field input[type="text"] {
  width: 100%;
  background: #1e1f22;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 12px;
  color: #fff;
  outline: none;
}

.add-field input[type="file"] {
  font-size: 11px;
  color: #cbd5e1;
}

.add-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
}

.add-actions button {
  padding: 8px 14px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  border: none;
}

.btn-cancel {
  background: rgba(255, 255, 255, 0.08);
  color: #cbd5e1;
}

.btn-save {
  background: #5865F2;
  color: #fff;
}

.btn-save:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/Soundboard/SoundboardModal.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,gFAAgF;EAChF,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,8CAA8C;AAChD;;AAEA,SAAS;AACT;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kCAAkC;EAClC,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* Soundboard Modal & Popover */\n.soundboard-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 99999;\n  background: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: fadeIn 0.15s ease-out;\n}\n\n.soundboard-backdrop.bottom-sidebar {\n  align-items: flex-end;\n  justify-content: flex-start;\n  padding-left: 80px;\n  padding-bottom: 75px;\n  background: transparent;\n  backdrop-filter: none;\n}\n\n.soundboard-modal-container {\n  width: 440px;\n  max-width: 95vw;\n  background: #1e1f22;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 14px;\n  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.65), 0 0 0 1px rgba(255, 255, 255, 0.05);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: scaleIn 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes scaleIn {\n  from { opacity: 0; transform: scale(0.94) translateY(10px); }\n  to { opacity: 1; transform: scale(1) translateY(0); }\n}\n\n.soundboard-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 18px;\n  background: #2b2d31;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.soundboard-title-group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.soundboard-icon-badge {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: linear-gradient(135deg, #5865F2, #8b5cf6);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(88, 101, 242, 0.4);\n}\n\n.soundboard-header h3 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 800;\n  color: #fff;\n}\n\n.soundboard-close-btn {\n  background: transparent;\n  border: none;\n  color: #94a3b8;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n}\n\n.soundboard-close-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n/* Toolbar */\n.soundboard-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 16px;\n  background: #232428;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.soundboard-search-box {\n  flex: 1;\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.soundboard-search-box .search-icon {\n  position: absolute;\n  left: 10px;\n  color: #80848e;\n  pointer-events: none;\n}\n\n.soundboard-search-input {\n  width: 100%;\n  background: #111214;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 8px;\n  padding: 7px 12px 7px 32px;\n  font-size: 12px;\n  color: #fff;\n  outline: none;\n  transition: border-color 0.15s;\n}\n\n.soundboard-search-input:focus {\n  border-color: #5865F2;\n}\n\n.soundboard-vol-control {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.vol-icon-btn {\n  background: transparent;\n  border: none;\n  color: #94a3b8;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px;\n}\n\n.soundboard-vol-slider {\n  width: 75px;\n  height: 4px;\n  accent-color: #5865F2;\n  cursor: pointer;\n}\n\n.vol-text {\n  font-size: 11px;\n  color: #94a3b8;\n  font-family: monospace;\n  min-width: 28px;\n}\n\n/* Tabs */\n.soundboard-tabs {\n  display: flex;\n  gap: 6px;\n  padding: 10px 16px 6px 16px;\n  overflow-x: auto;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.soundboard-tab-btn {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid transparent;\n  color: #94a3b8;\n  padding: 5px 12px;\n  border-radius: 14px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.15s;\n}\n\n.soundboard-tab-btn:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n}\n\n.soundboard-tab-btn.active {\n  background: #5865F2;\n  color: #fff;\n  box-shadow: 0 2px 8px rgba(88, 101, 242, 0.35);\n}\n\n/* Grid */\n.soundboard-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  gap: 10px;\n  padding: 14px 16px;\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n.sound-tile {\n  position: relative;\n  background: #2b2d31;\n  border: 1px solid rgba(255, 255, 255, 0.07);\n  border-radius: 10px;\n  padding: 12px 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  user-select: none;\n}\n\n.sound-tile:hover {\n  background: #35373c;\n  border-color: rgba(88, 101, 242, 0.5);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.35);\n}\n\n.sound-tile:active {\n  transform: scale(0.96);\n  background: #5865F2;\n}\n\n.sound-emoji {\n  font-size: 26px;\n  line-height: 1;\n}\n\n.sound-name {\n  font-size: 12px;\n  font-weight: 700;\n  color: #e2e8f0;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n}\n\n.sound-tile:hover .sound-name {\n  color: #fff;\n}\n\n.sound-delete-btn {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  background: rgba(239, 68, 68, 0.2);\n  border: none;\n  color: #ef4444;\n  border-radius: 4px;\n  padding: 2px 4px;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 0.15s;\n}\n\n.sound-tile:hover .sound-delete-btn {\n  opacity: 1;\n}\n\n.sound-tile.add-tile {\n  border: 1px dashed rgba(255, 255, 255, 0.2);\n  background: rgba(255, 255, 255, 0.02);\n  color: #94a3b8;\n}\n\n.sound-tile.add-tile:hover {\n  background: rgba(88, 101, 242, 0.1);\n  border-color: #5865F2;\n  color: #5865F2;\n}\n\n/* Add custom sound modal */\n.soundboard-add-modal-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(2px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  z-index: 100;\n}\n\n.soundboard-add-modal {\n  width: 100%;\n  max-width: 340px;\n  background: #2b2d31;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 12px;\n  padding: 18px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);\n}\n\n.soundboard-add-modal h4 {\n  margin: 0 0 6px 0;\n  font-size: 15px;\n  font-weight: 800;\n  color: #fff;\n}\n\n.soundboard-add-modal p {\n  margin: 0 0 14px 0;\n  font-size: 11px;\n  color: #94a3b8;\n  line-height: 1.4;\n}\n\n.add-field {\n  margin-bottom: 12px;\n}\n\n.add-field label {\n  display: block;\n  font-size: 11px;\n  font-weight: 700;\n  color: #cbd5e1;\n  margin-bottom: 5px;\n}\n\n.add-field input[type=\"text\"] {\n  width: 100%;\n  background: #1e1f22;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 6px;\n  padding: 8px 10px;\n  font-size: 12px;\n  color: #fff;\n  outline: none;\n}\n\n.add-field input[type=\"file\"] {\n  font-size: 11px;\n  color: #cbd5e1;\n}\n\n.add-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n.add-actions button {\n  padding: 8px 14px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  border: none;\n}\n\n.btn-cancel {\n  background: rgba(255, 255, 255, 0.08);\n  color: #cbd5e1;\n}\n\n.btn-save {\n  background: #5865F2;\n  color: #fff;\n}\n\n.btn-save:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
